import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, change, isSubmitting, isDirty, getFormValues } from 'redux-form';

import objectDiff from 'utils/objectDiff';

import Button from 'components/common/Button';
import HCPCSCodeCreateEditForm from './HCPCSCodeCreateEditForm';

const styles = theme => ({
  form: {
    overflow: 'hidden',
    padding: '20px 50px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px 0',
    },
  },
});

class HCPCSCodeCreateEditDialog extends Component {
  constructor(props) {
    super(props);

    this.onCopy = this.onCopy.bind(this);
  }

  onCopy(variant) {
    const { formValues, form, actions } = this.props;
    if (variant === 'Medicaid All') {
      if (formValues['Medicaid Description']) {       
        actions.change(form, 'Medicare Description', formValues['Medicaid Description']);
      }
      if (formValues['Medicaid Sale Price']) {
        actions.change(form, 'Medicare Sale Price', formValues['Medicaid Sale Price']);
      }
      if (formValues['Medicaid Rental Price']) {
        actions.change(form, 'Medicare Rental Price', formValues['Medicaid Rental Price']);
      }
      if (formValues['Medicaid Sale Price Rural']) {
        actions.change(form, 'Medicare Sale Price Rural', formValues['Medicaid Sale Price Rural']);
      }
      if (formValues['Medicaid Rental Price Rural']) {
        actions.change(form, 'Medicare Rental Price Rural', formValues['Medicaid Rental Price Rural']);
      }
    }
    if (variant === 'Medicare All') {
      if (formValues['Medicare Description']) {       
        actions.change(form, 'Medicaid Description', formValues['Medicare Description']);
      }
      if (formValues['Medicare Sale Price']) {
        actions.change(form, 'Medicaid Sale Price', formValues['Medicare Sale Price']);
      }
      if (formValues['Medicare Rental Price']) {
        actions.change(form, 'Medicaid Rental Price', formValues['Medicare Rental Price']);
      }
      if (formValues['Medicare Sale Price Rural']) {
        actions.change(form, 'Medicaid Sale Price Rural', formValues['Medicare Sale Price Rural']);
      }
      if (formValues['Medicare Rental Price Rural']) {
        actions.change(form, 'Medicaid Rental Price Rural', formValues['Medicare Rental Price Rural']);
      }
    }
    if (variant === 'Medicaid Description') {         
      actions.change(form, 'Medicare Description', formValues['Medicaid Description']);
    }
    if (variant === 'Medicare Description') {
      actions.change(form, 'Medicaid Description', formValues['Medicare Description']);
    }
  }

  render() {
    const {
      open,
      onClose,
      ID,
      onSubmitSuccess,
      form,
      formValues,
      initialValues,
      actions,
      dirty,
      submitting,
      State,
      classes,
    } = this.props;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
      >
        <DialogTitle>
          <Typography
            variant="title"
            color="secondary"
            align="center"
          >
            {ID ? 'Edit HCPCS Code' : 'New HCPCS Code'}
          </Typography>
        </DialogTitle>
        <DialogContent withScrollbars>
          <HCPCSCodeCreateEditForm
            className={classes.form}
            onSubmitSuccess={onSubmitSuccess}
            form={form}
            {...ID ? { ID } : {}}
            {...initialValues ? { initialValues } : {}}
            onCopy={this.onCopy}
            State={State}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            variant="raised"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (ID) {
                if (Object.keys(objectDiff(formValues, initialValues)).length > 0) {
                  actions.submit(form);
                } else {
                  onClose();
                }
              } else if (dirty) {
                actions.submit(form);
              } else {
                onClose();
              }
            }}
            variant="raised"
            color="primary"
            disabled={submitting}
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

HCPCSCodeCreateEditDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  form: PropTypes.string,
  ID: PropTypes.number,
  initialValues: PropTypes.shape({
    'Vendor Name': PropTypes.string,
  }),
  submitting: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  formValues: PropTypes.shape({
    'HCPC S Code': PropTypes.string,
  }),
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  State: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

HCPCSCodeCreateEditDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSubmitSuccess: () => {},
  form: 'hcpcsCodeCreate',
  initialValues: null,
  ID: null,
  formValues: null,
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
  dirty: isDirty(ownProps.form)(store),
  formValues: getFormValues(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit, change }, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(HCPCSCodeCreateEditDialog),
);



// WEBPACK FOOTER //
// ./src/components/settings/HCPCSCodeCreateEditDialog/HCPCSCodeCreateEditDialog.js